import indexOf from 'lodash/indexOf';
import map from 'lodash/map';

export const generatePaginationObj = (page = 1, limit = 10) => {
  const offset = (page - 1) * limit;
  return {
    offset,
    limit,
  };
};

export const replaceMultiple = (string, mapObj) => {
  const re = new RegExp(Object.keys(mapObj).join('|'), 'gi');
  string = string.replace(re, (matched) => mapObj[matched]);
  return string;
};

export const hasPermission = (master, sub) => {
  let allow = true;
  map(sub, (s) => {
    if (indexOf(master, s) === -1) {
      allow = false;
    }
  });
  return allow;
};

export const hasAnyPermission = (master, sub) => {
  let allow = false;
  map(sub, (s) => {
    if (indexOf(master, s) >= 0) {
      allow = true;
    }
  });
  return allow;
};
